import React, { useEffect } from "react";
import { useLocation } from "react-router-dom"; // Import useLocation
import ENImage from "../china-europe/china-europe-main/img/gb.svg";
import UAImage from "../china-europe/china-europe-main/img/ua.svg";
import CZImage from "../china-europe/china-europe-main/img/cz.svg";
import { useTranslation } from "react-i18next";
import { IoIosArrowDown } from "react-icons/io";
import "./style/lang-select.css";

const languages = [
  { code: "en", img: ENImage },
  { code: "ua", img: UAImage },
  { code: "cz", img: CZImage },
];

export default function LangSelect({ className, isOpen, setIsOpen, onClick }) {
  const { i18n } = useTranslation();
  const location = useLocation(); // Get the current route

  const changeLanguage = (langCode) => {
    i18n.changeLanguage(langCode);
    localStorage.setItem("selectedLanguage", langCode);
    console.log(i18n.language);
    setIsOpen(false);
  };

  const isChinaEuropeRoute = location.pathname === "/china-europe";

  return (
    <div className={`lg-lang-selector ${className}`}>
      <div
        className="lg-lang-select"
        onClick={() => {
          setIsOpen(!isOpen);
        }}
      >
        <img
          className="lg-lang-select-img"
          src={languages.find((lang) => lang.code === i18n.language)?.img}
          alt={i18n.language}
        />
        <IoIosArrowDown />
      </div>

      {isOpen && (
        <ul className="lg-lang-dropdown">
          {languages.map((lang) =>
            // Exclude Ukrainian language if the route is /china-europe
            lang.code === i18n.language ? null : lang.code === "ua" &&
              isChinaEuropeRoute ? null : (
              <li
                className="lg-lang-dropdown-item"
                key={lang.code}
                onClick={() => {
                  changeLanguage(lang.code);
                  onClick();
                }}
              >
                <img
                  className="lg-lang-select-img"
                  src={lang.img}
                  alt={lang.code}
                />
              </li>
            )
          )}
        </ul>
      )}
    </div>
  );
}
